/**
 * Claim domain schemas — canonical shape for TMS freight claim records.
 */
import { z } from 'zod';

export const CLAIM_STATUS = Object.freeze({
  SUBMITTED:    'submitted',
  UNDER_REVIEW: 'under_review',
  APPROVED:     'approved',
  DENIED:       'denied',
  PAID:         'paid',
  CLOSED:       'closed',
});

export const ClaimStatusEnum = z.enum(Object.values(CLAIM_STATUS));

export const ClaimSchema = z.object({
  claimId:     z.string().optional(),
  tenantId:    z.string(),
  loadId:      z.string().optional(),
  status:      ClaimStatusEnum,
  claimType:   z.enum(['damage', 'shortage', 'loss', 'delay', 'other']).optional(),
  claimAmount: z.number().nonnegative().optional(),
  description: z.string().optional(),
  createdAt:   z.string().optional(),
  updatedAt:   z.string().optional(),
}).passthrough();
